import { ChangeDetectionStrategy, Component } from '@angular/core';

import { environment } from '@environments/environment';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-newsletter-block',
  templateUrl: './newsletter-block.component.html',
})
export class NewsletterBlockComponent {
  env = environment.newsletterScriptUrl;
}
